import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import TextLabel from '../textLabel/textLabel';
import ArrowExpanded from '../treeSectionDivider/arrowExpanded';

var TreeListItem = function TreeListItem(props) {
  var alwaysShowSuffix = props.alwaysShowSuffix,
      collapseState = props.collapseState,
      dataHook = props.dataHook,
      depth = props.depth,
      getClassName = props.getClassName,
      highlight = props.highlight,
      icon = props.icon,
      label = props.label,
      labelSuffix = props.labelSuffix,
      onClick = props.onClick,
      onDoubleClick = props.onDoubleClick,
      selected = props.selected,
      shouldTranslate = props.shouldTranslate,
      suffix = props.suffix,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size;
  return /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHook,
    className: getClassName(classNames('tree-list-item', {
      selected: selected,
      highlight: highlight
    }, size)),
    onClick: onClick,
    onDoubleClick: onDoubleClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "depth-margin",
    style: {
      '--baseui-tree-list-item-depth': depth
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "tree-list-item-arrow-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tree-list-item-arrow ".concat(collapseState)
  }, /*#__PURE__*/React.createElement(ArrowExpanded, null))), icon && /*#__PURE__*/React.createElement("div", {
    className: "tree-list-item-icon"
  }, icon), /*#__PURE__*/React.createElement("div", {
    className: "tree-list-item-text-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tree-list-item-text"
  }, /*#__PURE__*/React.createElement(TextLabel, {
    dataHook: "label",
    value: label,
    type: "T20",
    shouldTranslate: shouldTranslate
  })), labelSuffix && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextLabel, {
    dataHook: "label-suffix",
    className: "label-suffix",
    value: labelSuffix,
    type: "T20",
    enableEllipsis: false,
    shouldTranslate: shouldTranslate
  }))), suffix && /*#__PURE__*/React.createElement("div", {
    className: classNames('tree-list-item-suffix', {
      'show-suffix': alwaysShowSuffix
    })
  }, suffix));
};

TreeListItem.displayName = displayNames.TREE_LIST_ITEM;
TreeListItem.propTypes = {
  alwaysShowSuffix: PropTypes.bool,
  collapseState: PropTypes.oneOf(['none', 'collapsed', 'expanded']),
  dataHook: PropTypes.string,
  depth: PropTypes.number,
  highlight: PropTypes.bool,
  icon: PropTypes.node,
  label: PropTypes.string.isRequired,
  labelSuffix: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onDoubleClick: PropTypes.func,
  selected: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium']),
  suffix: PropTypes.node
};
TreeListItem.defaultProps = {
  alwaysShowSuffix: false,
  collapseState: 'none',
  depth: 0,
  highlight: false,
  onDoubleClick: _.noop,
  selected: false,
  size: 'medium'
};
export default compose(TreeListItem);